<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <div id="app">
    <!-- here because of compatibility with prerender SPA plugin !-->
    <div id="top" class="page">
      <top-slider v-if="$i18n.locale === 'en'">
        <top-title-bar slot="bottom-bar"></top-title-bar>
      </top-slider>
      <top-slider-cs v-if="$i18n.locale === 'cs'">
        <top-title-bar slot="bottom-bar"></top-title-bar>
      </top-slider-cs>
      <about-me></about-me>
      <what-i-do></what-i-do>
      <contact-me></contact-me>
      <page-footer></page-footer>
    </div>
  </div>
</template>

<script>
import topSlider from "./../components/top-slider.vue";
import topSliderCs from "./../components/top-slider-cs.vue";
import topTitleBar from "./../components/top-title-bar.vue";
import aboutMe from "./../components/about-me.vue";
import whatIDo from "./../components/what-i-do";
import contactMe from "./../components/contact-me";
import pageFooter from "./../components/footer";

export default {
  name: "home",
  components: {
    topSlider,
    topTitleBar,
    topSliderCs,
    aboutMe,
    whatIDo,
    contactMe,
    pageFooter
  }
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
}
</style>
